module.exports = __webpack_public_path__ + "img/携程_02.347d9622.jpg";